<script setup>
import { computed } from "vue";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  orientation: { type: String, default: "horizontal" },
  decorative: { type: Boolean, default: true },
  class: { type: String, default: "" },
});

const classes = computed(() =>
  cn(
    "shrink-0 bg-gray-200",
    props.orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
    props.class
  )
);
</script>

<template>
  <div
    :role="decorative ? 'none' : 'separator'"
    :aria-orientation="decorative ? undefined : orientation"
    :class="classes"
  />
</template>
